const HeroSection = () => {
  return (
    <div 
      className="relative py-24 px-4 bg-cover bg-center bg-no-repeat overflow-hidden"
      style={{
        backgroundImage: "url('/lovable-uploads/f553c14d-d6d0-46da-8583-4479b29d6b40.png')"
      }}
    >
      <div className="absolute inset-0 bg-primary/80"></div>
      <div className="container mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-white/20 text-white px-4 py-2 rounded-full text-sm font-medium mb-8 border border-white/30 backdrop-blur-sm">
          About SeniorThrive
        </div>
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-8 tracking-tight leading-hero">
          We Believe You Deserve to{" "}
          <span className="text-accent font-bold">
            Thrive at Home
          </span>
        </h1>
        <div className="max-w-3xl mx-auto space-y-6">
          <p className="text-xl md:text-2xl text-white/90 leading-relaxed">
            SeniorThrive empowers older adults to live safely and independently in their own homes 
            while staying connected with family and caregivers.
          </p>
          <div className="bg-white/20 backdrop-blur-sm border border-white/30 rounded-2xl p-6 shadow-lg">
            <p className="text-lg font-semibold text-white">
              We're not about managing decline—we're about taking control and living fully in later life.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;